module.exports = __webpack_public_path__ + "img/abgame-home.f0237d49.jpg";